/**
 * Company summary from login/refresh (user.contact.company).
 * @typedef {{ id: number, name: string, category?: { id?: number, name?: string } | null, [key: string]: unknown }} CompanyBrief
 */

export function serializeCompanyBrief(company) {
  if (company == null) return "";
  try {
    return JSON.stringify(company);
  } catch (_error) {
    return "";
  }
}

export function parseCompanyBrief(raw) {
  if (!raw || raw === "") return null;
  try {
    const parsed = JSON.parse(raw);
    if (parsed == null || typeof parsed !== "object") return null;
    if (parsed.id == null) return null;
    return parsed;
  } catch (_error) {
    return null;
  }
}

export function parseContactId(raw) {
  if (raw == null || raw === "") return null;
  const n = parseInt(String(raw), 10);
  return Number.isFinite(n) && n > 0 ? n : null;
}
